module.exports = __webpack_public_path__ + "img/bn21.af29590e.png";